module.exports = __webpack_public_path__ + "img/1455705899.ffea2553.jpg";